module.exports = __webpack_public_path__ + "static/media/logo-video.9b8dcdfd.png";